module.exports = __webpack_public_path__ + "static/media/bicycle-bell.f8a3a4bc.mp3";